import React, { useState } from 'react';
import { InputGroup, Legend, Alert, Title, Text } from '@gjensidige/builders-components';
import { IGroupOptionsProps, IValueOptions } from '../../interfaces/EnquiryInterface';
import { Validator } from '../../utils/Validator';
import { AppConstants } from '../../utils/AppConstants';
import { HelpText } from './HelpText';
import tracker from '../../tracking';
export const EnquiryOptionsGroups: React.FC<IGroupOptionsProps> = (
  props: IGroupOptionsProps
) => {
  const [isValid, setIsValid] = useState(true);

  const handleChange = (value: string[]) => {
    const selectedValue = value[0];
    const inputStatus = Validator.validate(
      props.questionType,
      selectedValue,
      ''
    );
    /***
      Custom tracking as the builders component version used in the app does not track scenario label and steps.
      Fix for https://gjensidige.atlassian.net/browse/SE-6433
      TODO: Remove the custom tracking once we migrated to new builders-components, if it supports the desired tracking.
    ***/
    const selectedLabel = props.options?.find((option: IValueOptions) => option.value === selectedValue)?.label || '';
    tracker.trackEvent({
      "eventLabel": props.labelText,
      "eventStatus": selectedLabel,
      "eventAction": "checked",
      "eventCategory": props.inputType === "RadioButtonList" ? "radio" : props.inputType,
      "eventKey": "input-group-simple"
    })
    setIsValid(inputStatus.isValid);
    props.handleChange(props.questionType, selectedValue, inputStatus.isValid);
  };
  return (<>
    {props.helpText && 
      <HelpText labelText={props.labelText} message={props.helpText} helpTextClassName="help-text-wrapper" referenceId={props.questionType}/>
    }
    <InputGroup
      id={props.questionType}
      name={`${props.questionType}-options`}
      onChange={handleChange}
      type={props.inputType === "RadioButtonList" ? "radio" : props.inputType}
      value={props.selectedValue}
      className={`${props.alignCenter && 'enquiry-justify-content'}`}
      tracking={false}
      variant="column"
      {...props.ariaDescribedBy ? { 'aria-describedby': props.ariaDescribedBy } : {}}
    >
      {props.labelText && !props.helpText &&
        <Legend className="enquiry-group-label">{props.labelText}
        </Legend>
      }
      {props.labelDescription && <Text size="body"> {props.labelDescription} </Text>}
      {
        props.options?.map((option: IValueOptions) => (
          <InputGroup.Input key={option.value} label={{
              className: 'enquiry-group-opton-label',
              children: option.label
            }} 
            value={option.value} />
        ))
      }
    </InputGroup>
    {!isValid && (
        <Alert
          className="option-enquiry-invalid-info"
          severity="warning"
        >
          <Title className="no-margin-bottom">{AppConstants.getAppText(`webshop.mc.${props.questionType}.invalidLabel`)}</Title>
          <div dangerouslySetInnerHTML={{__html: AppConstants.getAppText(`webshop.mc.${props.questionType}.invalidText`)}}/>
        </Alert>
    )}
    </>
  );
};
